module.exports = __webpack_public_path__ + "img/beef-kebabs.479dc263.jpg";